<template>
  <div class="m-page m-service-page">
    <section class="m-service-top">
      <article
        v-for="item in serviceCards"
        :key="item.title"
        class="m-service-block"
      >
        <h2 class="m-service-title">{{ item.title }}</h2>
        <div class="m-info-card m-service-card">
          <p class="m-service-desc">{{ item.desc }}</p>
          <div class="m-service-card-main">
            <div class="m-tag-list">
              <span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
            </div>
            <img class="m-service-img" :src="item.img" :alt="item.title" />
          </div>
        </div>
      </article>
    </section>

    <section class="m-section">
      <h2>平台交易保障</h2>
      <p class="m-section-subtitle">在线交易，尊享多重保障，装修超省心</p>

      <article
        v-for="item in guaranteeCards"
        :key="item.title"
        class="m-info-card m-guarantee-card"
        :class="{ 'has-icon': item.img }"
      >
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
        <img v-if="item.img" class="m-card-icon" :src="item.img" :alt="item.title" />
      </article>
    </section>

    <section class="m-section m-flow-section">
      <h2>在线交易流程</h2>
      <p class="m-section-subtitle">两种下单模式随心选，均可享平台保障</p>
      <div class="m-flow-toggle">
        <button
          type="button"
          :class="['m-flow-btn', { active: flowActive === 'left' }]"
          @click="setFlow('left')"
        >
          比价下单
        </button>
        <button
          type="button"
          :class="['m-flow-btn', { active: flowActive === 'right' }]"
          @click="setFlow('right')"
        >
          邀约下单
        </button>
      </div>
      <img
        class="m-flow-img"
        :src="flowActive === 'left' ? flowImgs.left : flowImgs.right"
        :alt="flowActive === 'left' ? '比价下单流程' : '邀约下单流程'"
      />
    </section>

    <section id="experience" class="m-section m-experience-section">
      <h2>立即体验</h2>
      <p class="m-section-subtitle">服务至业主满意为止，不负每个客户的信任</p>
      <!-- <button class="m-secondary-btn" type="button" @click="openQrModal">立即体验</button> -->
      <img class="m-experience-qrs" src="https://obs.huahuaeco.com/official/product1.png" alt="扫码体验小程序与关注官方服务号" />
    </section>

    <div v-if="showQrModal" class="m-qr-overlay" @click.self="closeQrModal">
      <div class="m-qr-dialog" role="dialog" aria-modal="true" aria-label="小程序二维码">
        <button class="m-qr-close" type="button" aria-label="关闭二维码" @click="closeQrModal">×</button>
        <img :src="qrCodeUrl" alt="化化小程序二维码" />
      </div>
    </div>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../../utils/page-head'
import SeoStaticImages from '../../components/SeoStaticImages.vue'

export default {
  name: 'ProductMobilePage',
  components: {
    SeoStaticImages
  },
  setup() {
    useHead(getPageHead('decorationServices', 'https://www.huahuaeco.com/decorationServices'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/product2.png',
        'https://obs.huahuaeco.com/official/product3.png',
        'https://obs.huahuaeco.com/official/product4.png',
        'https://obs.huahuaeco.com/official/Product/img5safe.png',
        'https://obs.huahuaeco.com/official/HomeM/comparePriceMobile.png',
        'https://obs.huahuaeco.com/official/HomeM/directOrderMobile.png',
        'https://obs.huahuaeco.com/official/product1.png',
        'https://obs.huahuaeco.com/official/qrcode.png'
      ],
      serviceCards: [
        {
          title: '专属定制，帮您设计理想家',
          desc: '提供全流程设计服务，从户型规划、预算清单到选材建议，为您的理想家保驾护航。',
          tags: ['图纸设计', '造价清单', '选材建议', '施工跟进', '摆场指导'],
          img: 'https://obs.huahuaeco.com/official/product2.png'
        },
        {
          title: '师傅手艺好，干活不马虎',
          desc: '我们严选经验扎实的师傅团队，从细节到整体，把靠谱落到实处。',
          tags: ['拆除工', '水电工', '泥瓦工', '油漆工', '木工'],
          img: 'https://obs.huahuaeco.com/official/product3.png'
        },
        {
          title: '自营装企，全程兜底，安心不用盯',
          desc: '我们以自营模式把控装修全流程，让您告别“盯工地”的疲惫。',
          tags: ['客户至上', '不主动增项', '在线签约', '规范施工', '满意为止'],
          img: 'https://obs.huahuaeco.com/official/product4.png'
        }
      ],
      guaranteeCards: [
        {
          title: '先装修后付款，掌握装修主动权',
          desc: '平台担保交易模式，客户先付款至平台，验收通过后再付款给服务方，保障业主的资金安全及主动权。',
          img: 'https://obs.huahuaeco.com/official/Product/img5safe.png'
        },
        {
          title: '关键数据留痕，装修维权不再难',
          desc: '沟通记录、报价方案、电子签约、变更记录、验收记录等关键数据在线留存。'
        },
        {
          title: '售后保障服务，解决后顾之忧',
          desc: '服务方按约承担售后服务，未履约时平台将介入处理，保障业主权益。'
        },
        {
          title: '平台托底保障，服务至满意为止',
          desc: '若合作破裂且协商不成，可申请平台托底服务，由平台自营团队接管。'
        }
      ],
      flowActive: 'left',
      flowImgs: {
        left: 'https://obs.huahuaeco.com/official/HomeM/comparePriceMobile.png',
        right: 'https://obs.huahuaeco.com/official/HomeM/directOrderMobile.png'
      },
      qrCodeUrl: 'https://obs.huahuaeco.com/official/qrcode.png',
      showQrModal: false
    }
  },
  methods: {
    setFlow(side) {
      this.flowActive = side
    },
    openQrModal() {
      this.showQrModal = true
    },
    closeQrModal() {
      this.showQrModal = false
    }
  }
}
</script>

<style scoped lang="scss">
.m-page {
  min-height: 100vh;
  padding-top: calc(88 * var(--rpx));
  background: #f4f7fb;
  overflow: hidden;
}

.m-secondary-btn {
  display: block;
  width: calc(220 * var(--rpx));
  height: calc(62 * var(--rpx));
  margin: calc(36 * var(--rpx)) auto 0;
  border: 0;
  border-radius: calc(999 * var(--rpx));
  color: #fff;
  font-size: calc(24 * var(--rpx));
  font-weight: 600;
  background: linear-gradient(90deg, #5bf7fe, #198cfe);
  box-shadow: 0 calc(12 * var(--rpx)) calc(22 * var(--rpx)) rgba(25, 140, 254, 0.22);
}

.m-section {
  padding: calc(56 * var(--rpx)) calc(24 * var(--rpx)) 0;

  h2 {
    margin: 0;
    color: #262626;
    text-align: center;
    font-size: calc(34 * var(--rpx));
    font-weight: 700;
    line-height: 1.35;
  }
}

.m-section-subtitle {
  width: calc(620 * var(--rpx));
  max-width: 100%;
  margin: calc(18 * var(--rpx)) auto 0;
  color: #8c8c8c;
  text-align: center;
  font-size: calc(22 * var(--rpx));
  line-height: 1.6;
}

.m-info-card {
  margin-top: calc(24 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(14 * var(--rpx)) calc(36 * var(--rpx)) rgba(56, 89, 126, 0.06);
}

.m-service-top {
  padding: calc(48 * var(--rpx)) calc(24 * var(--rpx)) 0;
}

.m-service-block + .m-service-block {
  margin-top: calc(58 * var(--rpx));
}

.m-service-title {
  margin: 0 0 calc(28 * var(--rpx));
  color: #262626;
  text-align: center;
  font-size: calc(34 * var(--rpx));
  font-weight: 700;
  line-height: 1.35;
}

.m-service-card {
  position: relative;
  min-height: calc(236 * var(--rpx));
  overflow: hidden;
  padding: calc(34 * var(--rpx)) calc(28 * var(--rpx)) calc(24 * var(--rpx));
}

.m-service-desc {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  color: #262626;
  font-size: calc(22 * var(--rpx));
  font-weight: 600;
  line-height: 1.65;
}

.m-service-card-main {
  position: relative;
  z-index: 2;
  min-height: calc(118 * var(--rpx));
  margin-top: calc(22 * var(--rpx));
}

.m-tag-list {
  display: grid;
  grid-template-columns: repeat(2, calc(112 * var(--rpx)));
  gap: calc(12 * var(--rpx));
  width: calc(236 * var(--rpx));

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: calc(42 * var(--rpx));
    padding: 0 calc(10 * var(--rpx));
    border-radius: calc(10 * var(--rpx));
    color: #fff;
    font-size: calc(20 * var(--rpx));
    font-weight: 500;
    line-height: 1;
    background: linear-gradient(90deg, #6fc6ff 0%, #5c9dff 100%);
    white-space: nowrap;
  }
}

.m-service-img {
  position: absolute;
  right: calc(10 * var(--rpx));
  bottom: 0;
  z-index: 1;
  width: calc(276 * var(--rpx));
  max-height: calc(170 * var(--rpx));
  object-fit: contain;
  object-position: right bottom;
}

.m-guarantee-card {
  position: relative;
  min-height: calc(190 * var(--rpx));
  overflow: visible;
  padding: calc(42 * var(--rpx)) calc(34 * var(--rpx));

  &.has-icon {
    margin-top: calc(100 * var(--rpx));
  }

  &.has-icon div {
    max-width: calc(500 * var(--rpx));
  }

  .m-card-icon {
    position: absolute;
    top: calc(-96 * var(--rpx));
    right: calc(54 * var(--rpx));
    width: calc(190 * var(--rpx));
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(26 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }

  p {
    margin: calc(14 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(22 * var(--rpx));
    line-height: 1.72;
  }
}

.m-flow-section {
  padding-bottom: calc(40 * var(--rpx));
}

.m-flow-toggle {
  display: flex;
  width: calc(460 * var(--rpx));
  max-width: 100%;
  margin: calc(28 * var(--rpx)) auto 0;
  padding: calc(6 * var(--rpx));
  border-radius: calc(999 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(12 * var(--rpx)) calc(30 * var(--rpx)) rgba(22, 95, 230, 0.1);
}

.m-flow-btn {
  flex: 1;
  height: calc(58 * var(--rpx));
  border: 0;
  border-radius: calc(999 * var(--rpx));
  background: transparent;
  color: #262626;
  font-size: calc(24 * var(--rpx));
  font-weight: 600;
}

.m-flow-btn.active {
  color: #fff;
  background: linear-gradient(90deg, #5bf7fe, #198cfe);
}

.m-flow-img {
  display: block;
  width: calc(686 * var(--rpx));
  max-width: 100%;
  height: auto;
  margin: calc(36 * var(--rpx)) auto 0;
}

.m-experience-section {
  padding-bottom: calc(80 * var(--rpx));
  background: #fff;
}

.m-experience-qrs {
  display: block;
  width: min(calc(640 * var(--rpx)), 88vw);
  height: auto;
  margin: calc(42 * var(--rpx)) auto 0;
  border-radius: calc(18 * var(--rpx));
}

.m-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--rpx));
  background: rgba(15, 23, 42, 0.42);
}

.m-qr-dialog {
  position: relative;
  width: min(calc(520 * var(--rpx)), 82vw);
  padding: calc(40 * var(--rpx));
  border-radius: calc(18 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(24 * var(--rpx)) calc(70 * var(--rpx)) rgba(15, 23, 42, 0.22);

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.m-qr-close {
  position: absolute;
  top: calc(10 * var(--rpx));
  right: calc(14 * var(--rpx));
  width: calc(46 * var(--rpx));
  height: calc(46 * var(--rpx));
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #8c8c8c;
  font-size: calc(38 * var(--rpx));
  line-height: calc(46 * var(--rpx));
}
</style>
